import type { components } from "./generated-schema";
import { apiRequest } from "./httpClient";

export type CurrentUser = components["schemas"]["CurrentUser"];

export function getCurrentUser(signal?: AbortSignal): Promise<CurrentUser> {
  return apiRequest<CurrentUser>("/auth/me", signal ? { signal } : {});
}